import { JSX } from 'react';
import { RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { RichTextRendering } from '@ahc-digital/component-library';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

export type C26RichTextProps = RenderingProps<C26RichTextFields, C26RichTextParams>;

export type C26RichTextParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C26RichTextFields = {
  RichText?: RichTextField;
};

const Default = (props?: C26RichTextProps): JSX.Element => {
  const { renderRichText } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <RichTextRendering
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    >
      {renderRichText(props?.fields?.RichText)}
    </RichTextRendering>
  );
};

export default checkDatasourceForRendering<C26RichTextProps>(Default);
